/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EnhanceCommentRequest} from '../models/EnhanceCommentRequest';
import type {Error} from '../models/Error';

export interface EnhanceComment$Request {
    enhanceCommentRequest: EnhanceCommentRequest;
}

export interface EnhanceComment$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enhanceCommentRequest = createAction<PayloadData<void, EnhanceComment$Request>>('AI_COMMENT_CONTROLLER__ENHANCE_COMMENT__REQUEST');
export const enhanceCommentSuccess = createAction<PayloadData<string, EnhanceComment$Request>>('AI_COMMENT_CONTROLLER__ENHANCE_COMMENT__SUCCESS');
export const enhanceCommentFailure = createAction<PayloadData<Error, EnhanceComment$Request, true>>('AI_COMMENT_CONTROLLER__ENHANCE_COMMENT__FAILURE');

export const enhanceCommentActions = [
    enhanceCommentRequest,
    enhanceCommentSuccess,
    enhanceCommentFailure
] as const;

/**
 * @param {EnhanceCommentRequest} meta.enhanceCommentRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enhanceComment = (meta: EnhanceComment$Request, config?: EnhanceComment$Config) => {
    return {
        CALL_API: {
            types: enhanceCommentActions,
            method: ApiMethods.POST,
            endpoint: `/ai/comments/enhance`,
            TRANSPORT_REQUEST_BODY: meta.enhanceCommentRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/plain, application/json',
            }
        },
        ...meta
    }
};

